import React, { useEffect, useState } from 'react';
import useGlobal from '../../store';
import ReactGA from 'react-ga';
import * as utils from '../../services/utils';
import CurrencySymbol from '../General/CurrencySymbol';

const ArchiveItemCard = (props) => {

    const [isSaving, setIsSaving] = useState(false);

    const [response, giftlistActions] = useGlobal(
        state => state.response,
        actions => actions.giftlistActions
    );

    const domain = function(input) {
        input = Array.isArray(input) ? input[0] : input;
        input = input.replace('www.', '');
        var l = document.createElement("a");
        l.href = input;
        return l.hostname;
    }

    const getItemUrl = (item) => {
        if(item.affURL) {
            return item.affURL;
        }
        if(!item.itemURLs || item.itemURLs === "") {
            return "#";
        }
        if(item.itemURLs.indexOf('amazon.com') !== -1 
            || item.itemURLs.indexOf('amazon.co.uk') !== -1
            || item.itemURLs.indexOf('amazon.de') !== -1
            || item.itemURLs.indexOf('amazon.fr') !== -1
            || item.itemURLs.indexOf('amazon.es') !== -1) {
            return formatAmazonUrl(item.itemURLs);
        } else if(item.itemURLs.includes("target.com")) {
            var t = item.itemURLs.match(/.*A-(.*?)($|#|\?)/);
            if(t && t.length > 1) {
                return 'https://goto.target.com/c/1430766/520943/2092?prodsku=' + t[1] + '&u=' + encodeURIComponent(item.itemURLs) + '&intsrc=PUI1_4061';
            }
        }
        return "http://go.redirectingat.com/?id=86675X1539295&xs=1&url="+encodeURI(item.itemURLs)+"&sref="+encodeURI(window.location.href);
    }
    const formatAmazonUrl = (linkUrl) => {
        linkUrl = decodeURIComponent(linkUrl);
        if(linkUrl.indexOf('christmasli0b-20') === -1) {
            var parts = linkUrl.split("?");
            if(parts.length > 1) {
                var params = JSON.parse('{"' + decodeURI(parts[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                params.tag = "christmasli0b-20";
                var queryString = Object.keys(params)
                        .map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) })
                        .join('&');
                linkUrl = parts[0] + "?" + queryString;
            } else {
                linkUrl += "?tag=christmasli0b-20"; 
            }
        }
        return linkUrl;
    }

    const openLink = (item) => {
        let itemUrl = getItemUrl(item);
        window.open(itemUrl, '_blank');

        //TRACK REFERRAL CLICK EVENT
        let domain = utils.getDomain(item.itemURLs);
        let evtVal = item.itemPrice ? parseInt(item.itemPrice, 10) : 1;
        ReactGA.event({
            category: 'Referral Click',
            action: 'Archive Item',
            label: domain,
            value: evtVal
        });
    }

    const addBack = () => {
        console.log('add item back');
        setIsSaving(true);
        giftlistActions.addArchivedItem({
            userID: props.userID,
            itemID: props.itemID
        });   
    }

    useEffect(() => {
        if(!response || response.type !== "addarchiveditem") {
            return;
        }
        setIsSaving(false);
    }, [response]);

    return ( 
        <div className="card item-card archive-card flex-apart" style={{flexDirection: "row"}}>
            <div className="kt-padding-10 text-center" style={{width: "100px"}} onClick={() => openLink(props)}>
                <img src={props.itemPic} alt="Item" style={{maxHeight: "70px"}} />
            </div>
            <div className="card-body" onClick={() => openLink(props)}>
                <h5 className="card-title">{props.itemName}</h5>
                <p className="card-text">{domain(props.itemURLs)} <i className="flaticon2-tag"></i></p>
                <p className="card-text hidden-xs">{props.itemDescription}</p>
            </div>
            <div className="badge badge-primary price-tag p-2 hover-cursor" onClick={() => openLink(props)}>
                <h4 className="p-0 m-0"><CurrencySymbol></CurrencySymbol>{props.itemPrice} <i className="la la-external-link"></i></h4>
            </div>
            <div className="text-right p-2">
                <button onClick={() => addBack()} className="btn btn-info mr-2">
                    ADD AGAIN
                    { isSaving ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></> }
                </button>
            </div>
        </div>);
}
export default ArchiveItemCard;